<div class="container-fluid py-4 px-3 px-md-5">
  <div class="card shadow-lg mx-auto border-0 rounded-4" style="max-width: 1000px;">
    <div class="card-header text-center py-3"
      style="background-color: #1e3a8a; color: white; border-radius: 0.8rem 0.8rem 0 0;">
      <h3 class="mb-0 fw-semibold">Agregar Un Nuevo Articulo</h3>
    </div>

    <div class="card-body bg-light p-4 p-md-5">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

        <!-- === Clasificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Clasificación</h5>
        <div class="row mb-4">
          <div class="col-12">
            <label>Sección</label>
            <input class="form-control" [value]="nombreSeccion()" [title]="nombreSeccion()" disabled>
          </div>
          <div class="col-12">
            <label>División</label>
            <input class="form-control" [value]="nombreDivision()" [title]="nombreDivision()" disabled>
          </div>
          <div class="col-12">
            <label>Clase</label>
            <input class="form-control" [value]="nombreClase()" [title]="nombreClase()" disabled>
          </div>
          <div class="col-12">
            <label>Producto</label>
            <input class="form-control" [value]="nombreProducto()" [title]="nombreProducto()" disabled>
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold">Variedad</label>
            <ng-select class="article-select" formControlName="fkVariedad"
              [items]="variedades()" bindLabel="nombre" bindValue="codigo"
              placeholder="Seleccione una variedad" [searchable]="true"
              [clearable]="true" appendTo="body" (change)="onVariedadChange()" />
          </div>
        </div>


        <!-- === Identificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Identificación</h5>

        <!-- Fila 1 -->
        <div class="row g-3 mb-3">
          <div class="col-12">
            <label>Código INE</label>
            <input formControlName="codigoIne" class="form-control form-control-lg"
              [class.is-invalid]="form.get('codigoIne')?.invalid && form.get('codigoIne')?.touched">
            @if (form.get('codigoIne')?.invalid && form.get('codigoIne')?.touched) {
            <div class="invalid-feedback">
              El código INE es obligatorio
            </div>
            }
          </div>

          <div class="col-12">
            <label>Nombre</label>
            <input formControlName="nombre" class="form-control form-control-lg"
              [class.is-invalid]="form.get('nombre')?.invalid && form.get('nombre')?.touched">
            @if (form.get('nombre')?.invalid && form.get('nombre')?.touched) {
            <div class="invalid-feedback">
              El nombre es obligatorio
            </div>
            }
          </div>
        </div>

        <!-- Fila 2 -->
        <div class="row g-3 mb-3">
          <div class="col-12">
            <label>Unidad de medida</label>
            <ng-select class="article-select" formControlName="fkUnidadMedida"
              [items]="getSelectedUnitMeasureOptions()" bindLabel="descripcion" bindValue="pk"
              placeholder="Seleccione una unidad" [searchable]="true"
              [clearable]="false" appendTo="body"
              (change)="onUnidadMedidaChange()" />
            @if (form.get('fkUnidadMedida')?.invalid && form.get('fkUnidadMedida')?.touched) {
            <div class="invalid-feedback">
              La unidad de medida es obligatoria
            </div>
            }
          </div>

          <div class="col-12">
            <label>Factor de conversión</label>
            <input type="number" step="0.0000001" class="form-control form-control-lg"
              formControlName="factorConversion" readonly
              [class.is-invalid]="form.get('factorConversion')?.invalid && form.get('factorConversion')?.touched">
            @if (form.get('factorConversion')?.invalid && form.get('factorConversion')?.touched) {
            <div class="invalid-feedback">
              El factor de conversión es obligatorio
            </div>
            }
          </div>
        </div>

        <!-- Fila 3 -->
        <div class="row g-3 mb-4">
          <div class="col-12">
            <label>Cálculo</label>
            <ng-select class="article-select" formControlName="calculo"
              [items]="yesNoOptions" bindLabel="label" bindValue="value"
              placeholder="Seleccione" [searchable]="false" [clearable]="true"
              appendTo="body"
              [class.is-invalid]="form.get('calculo')?.invalid && form.get('calculo')?.touched" />
            @if (form.get('calculo')?.invalid && form.get('calculo')?.touched) {
            <div class="invalid-feedback">
              El campo cálculo es obligatorio
            </div>
            }
          </div>

          <div class="col-12">
            <label>Cálculo alterno</label>
            <ng-select class="article-select" formControlName="calculoAlterno"
              [items]="yesNoOptions" bindLabel="label" bindValue="value"
              placeholder="Seleccione" [searchable]="false" [clearable]="true"
              appendTo="body"
              [class.is-invalid]="form.get('calculoAlterno')?.invalid && form.get('calculoAlterno')?.touched" />
            @if (form.get('calculoAlterno')?.invalid && form.get('calculoAlterno')?.touched) {
            <div class="invalid-feedback">
              El cálculo alterno es obligatorio
            </div>
            }
          </div>

          <div class="col-12">
            <label>Permite cotizar en Dólares</label>
            <ng-select class="article-select" formControlName="cotizarEnDolares"
              [items]="yesNoOptions" bindLabel="label" bindValue="value"
              placeholder="Seleccione" [searchable]="false" [clearable]="false"
              appendTo="body" />
          </div>
        </div>

        <!-- === Códigos de Clasificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Códigos de Clasificación</h5>
        <div class="row g-3 mb-4">
          <div class="col-12">
            <label>Código CIIU</label>
            <input formControlName="codigoCiiu" class="form-control" />
          </div>
          <div class="col-12">
            <label>Código NAEG</label>
            <input formControlName="codigoNaeg" class="form-control" />
          </div>
          <div class="col-12">
            <label>Código NPG</label>
            <input formControlName="codigoNpg" class="form-control" />
          </div>
          <div class="col-12">
            <label>Código CCP</label>
            <input formControlName="codigoCcp" class="form-control" />
          </div>
        </div>

        <!-- === Información Complementaria === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Información Complementaria</h5>
        <div class="row g-3 mb-4">
          <div class="col-12">
            <label>Referencia</label>
            <input formControlName="referencia" class="form-control" />
          </div>
          <div class="col-12">
            <label>Estado</label>
            <ng-select class="article-select" formControlName="estado"
              [items]="statusOptions" bindLabel="label" bindValue="value"
              placeholder="Seleccione un estado" [searchable]="false"
              [clearable]="true" appendTo="body" />
          </div>
        </div>

        <!-- === Guardar === -->
        <div class="text-center mt-4">
          <button type="submit" class="btn btn-lg btn-info text-white" [disabled]="form.invalid || loading()"
            title="Guarda el artículo ingresado">
            Guardar
          </button>

          <button type="button" class="btn btn-lg btn-danger" (click)="onCancel()"
            title="Cancela el registro y regresa a la pantalla anterior">
            Cancelar
          </button>
        </div>

        @if (success()) {
        <div class="alert alert-success mt-4 text-center">
          Artículo registrado correctamente.
        </div>
        }

        @if (error()) {
        <div class="alert alert-danger mt-4 text-center">
          {{ error() }}
        </div>
        }
      </form>
    </div>
  </div>
</div>
